export class EstImageSendQuoteModel {
  constructor() {
    this.quoteId = ''
    this.invoiceId = ''
    this.imageIds = []
    this.assessment = null
  }
}